import { defineMessages } from 'react-intl';

export default defineMessages({
    createButton: {
        id: 'interactiveLetterTable.dtcolumn.Create',
        defaultMessage: 'Create',
    }
});
